import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
export const PartnerBadge = ({ partner }) => {
    return _jsx(Typography, { children: partner.name });
};
